import React from 'react';

import "./styles/Filters.css";

const Refresh = () => {
  return (
    <div className='container'>
      <button className="buttonClear">Refresh Page</button>
    </div>
  );
};

export default Refresh;